module.exports = __webpack_public_path__ + "static/media/hdgz@3x.2fc6f57d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/hdgz@3x.png
// module id = 1761
// module chunks = 0 1